import React from 'react';
import BrandAlphaCardLink from './brandAlphaCardLink';

/*
    React function to display a distinct list of Brands based on
    alpha-numeric grouping per first character in Brand name ('3','A','B'...)
*/
export const BrandAlphaCard = (props) => {
    var header = props.data[0].trim().charAt(0);
    if (!isNaN(header)) {
        header = "#";
    }
    return (
        <div className="alpha-margin">
            <div className="boldtext">{header}</div>
            <hr className="brandListHr narrow"/>
            <ul className="faux-col">
                {props.data.map((listings, index) => <BrandAlphaCardLink key={index} data={listings} />)}
            </ul>
        </div>
    );
};